module.exports = __webpack_public_path__ + "7a3e86222d0d2b53a1c7d948e65b1299.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1152
// module chunks = 0